// material
import ModernTable from '../components/ModernTable';
import { useTheme } from '@mui/material/styles';
import { CloudDownload } from '@mui/icons-material';
import { Email } from '@mui/icons-material';
import request from '../../../services/Request';
import Swal from 'sweetalert2';
import { Typography, Box, Chip, alpha } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import { fShortenNumber } from './utils/formatNumber';
import { fCurrency } from './utils/formatNumber';
import { useState } from 'react';
import { useEffect } from 'react';
import ComputerIcon from '@mui/icons-material/Computer';
import DescriptionIcon from '@mui/icons-material/Description';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReceiptIcon from '@mui/icons-material/Receipt';

export default function TableUPC(props) {
  const theme = useTheme();
  const { soldProd, machinesName, endDate, startDate, prodInfo } = props;

  const MyNewTitle = ({ text = 'Table Title', variant = 'h6' }) => (
    <Typography variant={variant} style={{ overflow: 'hidden', textOverflow: 'ellipsis', marginTop: '20px' }}>
      {`Product Table (${machinesName} from ${startDate.toShortFormat()} to  ${endDate.toShortFormat()})`}
    </Typography>
  );

  const columns = [
    {
      title: 'Machine ID',
      field: 'name',
      render: (rowData) => (
        <Chip
          icon={<ComputerIcon sx={{ fontSize: 16 }} />}
          label={rowData.name}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.info.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Machine Desc',
      field: 'description',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
          {rowData.description}
        </Typography>
      ),
    },
    {
      title: 'Quantity Sold',
      field: 'quantity',
      render: (rowData) => (
        <Chip
          icon={<ShoppingCartIcon sx={{ fontSize: 16 }} />}
          label={rowData.quantity}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Cost Price(unit)',
      field: 'costPrice',
      render: (rowData) => (
        <Chip
          icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
          label={
            rowData.costPrice && rowData.costPrice !== '' ? fCurrency(rowData.costPrice) : 'N/A'
          }
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.error.main, 0.12),
            color: theme.palette.error.dark,
            border: `1.5px solid ${alpha(theme.palette.error.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.error.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Cost Price(total)',
      field: 'costPrice',
      render: (rowData) => (
        <Chip
          icon={<ReceiptIcon sx={{ fontSize: 16 }} />}
          label={
            rowData.costPrice && rowData.costPrice !== ''
              ? fCurrency(rowData.costPrice * rowData.quantity)
              : 'N/A'
          }
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.warning.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Unit Price',
      field: 'price',
      render: (rowData) => (
        <Chip
          icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
          label={fCurrency(rowData.soldPrice / rowData.quantity)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.success.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Sale Amount(before tax)',
      field: 'soldPrice',
      render: (rowData) => (
        <Chip
          icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
          label={fCurrency(rowData.soldPrice)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.secondary.main, 0.12),
            color: theme.palette.secondary.dark,
            border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.secondary.dark,
            },
          }}
        />
      ),
    },
  ];

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_upc') ? localStorage.getItem('table_view_upc') : 10
  );

  useEffect(() => {
    localStorage.setItem('table_view_upc', pagination);
  }, [pagination]);

  return (
    <ModernTable
      onRowsPerPageChange={setPagination}
      columns={columns}
      data={soldProd}
      title={<MyNewTitle variant="h6" />}
      options={{
        actionsColumnIndex: -1,
        pageSize: parseInt(pagination),
        pageSizeOptions: [5, 10, 20, 50, 100, 200],
      }}
      actions={[
        {
          tooltip: 'Download csv',
          isFreeAction: true,
          icon: CloudDownload,
          onClick: (evt, data) => {
            console.log(prodInfo);
            const outPutArray = soldProd.map((e) => {
              return {
                Machine_ID: e.name,
                Machine_Desc: e.description,
                Quantity_Sold: e.quantity,
                Unit_Cost_Price: e.costPrice?.toFixed(2),
                Total_Cost_Price: (e.costPrice * e.quantity)?.toFixed(2),
                Unit_Sold_Price: (e.soldPrice / e.quantity)?.toFixed(2),
                Sale_Amount: e.soldPrice?.toFixed(2),
              };
            });
            let csv = 'data:text/csv;charset=utf-8,';
            let header = Object.keys(outPutArray[0]).join(',');

            let values = outPutArray.map((o) => Object.values(o).join(',')).join('\n');

            csv += header + '\n' + values;

            var encodedUri = encodeURI(csv);
            var link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'my_product_data.csv');
            document.body.appendChild(link); // Required for FF

            link.click();
          },
        },
        {
          tooltip: 'Send to my email',
          isFreeAction: true,
          icon: Email,
          onClick: async (evt, data) => {
            const outPutArray = soldProd.map((e) => {
              return {
                Machine_ID: e.name,
                Machine_Desc: e.description,
                Quantity_Sold: e.quantity,
                Unit_Cost_Price: e.costPrice?.toFixed(2),
                Total_Cost_Price: (e.costPrice * e.quantity)?.toFixed(2),
                Unit_Sold_Price: (e.soldPrice / e.quantity)?.toFixed(2),
                Sale_Amount: e.soldPrice?.toFixed(2),
              };
            });
            let csv = '';
            let header = Object.keys(outPutArray[0]).join(',');

            let values = outPutArray.map((o) => Object.values(o).join(',')).join('\n');

            csv += header + '\n' + values;

            const { value: email } = await Swal.fire({
              title: 'Enter your email address',
              input: 'email',
              inputPlaceholder: 'Enter your email address',
            });
            if (email) {
              await request({
                method: 'post',
                url: '/email/sendcsv',
                data: {
                  email: email,
                  csv: csv,
                },
              }).then((res) => {
                Swal.fire(`The table has been send to your email as csv file.`);
              });
            }
          },
        },
      ]}
    />
  );
}
